import React from 'react'
import { Input as ReactstrapInput, InputProps } from 'reactstrap'

export const Input: React.FC<InputProps> = props => {
  return <ReactstrapInput {...props} />
}

export default Input
